import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { RoutesFacade, RouteDirectionFacade, RouteStopsFacade } from '@ridango/components';
import { keyCode, ListService } from '@ridango/core';

import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    selector: 'rwidget-route-stops',
    templateUrl: './route-stops.component.html',
    styleUrls: ['./route-stops.component.scss']
})
export class RouteStopsComponent extends BaseComponent implements OnInit, OnDestroy {
    private selectedIndex = 0;

    @Input() routeId: number;
    @Input() directionId: string;

    routeName: string = null;
    routeDirection: string;
    routeStopsIds = null;

    routeStops$ = this.routeStopsFacade.routeStops$;
    routeStopsIds$ = this.routeStopsFacade.ids$;
    routePolyline$ = this.routeStopsFacade.routePolyline$;
    stopsLoading$ = this.routeStopsFacade.loading$;
    routes$ = this.routesFacade.routes$;
    routeId$ = this.routesFacade.selectedRouteId$;

    @ViewChildren('listItem') listItems: QueryList<ElementRef>;
    constructor(
        private translate: TranslateService,
        private router: Router,
        private routesFacade: RoutesFacade,
        private routeDirectionFacade: RouteDirectionFacade,
        private routeStopsFacade: RouteStopsFacade,
        private listService: ListService
    ) {
        super();
    }

    ngOnInit() {
        this.routesFacade.setSelectedRouteId(this.routeId);
        this.routeDirectionFacade.setSelectedRouteDirection(this.directionId);
        this.routeStopsFacade.fetchRouteStops(this.routeId, this.directionId);
        this.routeStopsFacade.fetchRoutePolyline(this.routeId, this.directionId);

        this.routeStopsIds$.pipe(takeUntil(this.componentDestroyed$)).subscribe((id) => (this.routeStopsIds = id));

        this.routes$.pipe(takeUntil(this.componentDestroyed$)).subscribe((routes) => {
            if (routes && this.routeId && routes[this.routeId]) {
                this.routeName = routes[this.routeId].route_short_name;
            }
        });

        this.routeDirectionFacade
            .getRouteDirections(this.routeId)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((directions) => {
                if (directions) {
                    this.routeDirection = directions[this.directionId].trip_short_name;
                }
            });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.routeStopsFacade.resetRouteStops();
    }

    setFocusOnNextItem(event: KeyboardEvent, listSize: number) {
        switch (event.keyCode) {
            case keyCode.ARROW_DOWN:
                event.preventDefault();
                this.selectNextItem(1, listSize);
                break;
            case keyCode.ARROW_UP:
                event.preventDefault();
                this.selectNextItem(-1, listSize);
                break;
        }
    }

    private selectNextItem(stop: number, listSize): void {
        this.selectedIndex = this.listService.getNextCyclicIndex(this.selectedIndex, stop, listSize);
        setTimeout(() => this.listItems.toArray()[this.selectedIndex].nativeElement.focus());
    }

    back() {
        if (+this.directionId === 0) {
            this.router.navigate([this.translate.currentLang, 'schedule', 'routes']);
        } else {
            this.router.navigate([this.translate.currentLang, 'schedule', 'routes', this.routeId, 'directions']);
        }
    }
}
